import React, { useContext, useEffect, useRef, useState } from "react";
import {
  LAText,
  LAView,
  LAWarningPopup,
} from "../../components";
import { IMAGES, SVG_IMAGES } from "../../assets";
import { useLocation, useNavigate } from "react-router-dom";
import HTMLContent from "../../components/HTMLContent";
import ExplanationComponent from "../../components/ExplanationComponent";
import AnswerMessage from "../../components/AnswerMessage";
import { STRING, STRINGS } from "../../constant";
import { AuthContext } from "../../context/AuthProvider";
import { BundleContext } from "../../context/BundleProvider";
import { AppContext } from "../../context/AppProvider";
import { GET_APP_DOMAIN_LIST } from "../../../app_constant";
import { toHHMMSS } from "../../constant/strings";
import { ThemeContext } from "../../context/ThemeProvider";
import QuestionOptions from "../../components/common/QuestionOptions";
import {
  
  TestProgress,
  TestExitModal,
  TestEndModal,
  TestTimeUpModal
} from "../../components/test";
import CommonHeader from "../../components/common/CommonHeader";
import { faClipboardCheck } from "@fortawesome/free-solid-svg-icons";
import NavBar from "../../components/NavBar";
import {
  GET_CUSTOM_TEST_DETAILS,
  GET_PRACTICE_TEST_DETAILS,
  GET_QUESTION_FROM_ID,
  GET_RETAKE_TEST_DETAILS,
} from "../../api/test";
import { useAnalytics } from "../../context/AnalyticsProvider";

const Test = (props) => {
  const {
    profile,
    questionsList,
    community,
    setTestHistory,
    addQuestionScore,
    addAllQuestionScore,
    questionScrore,
  } = useContext(AuthContext);
  const {
    history,
    initalizePracticeTest,
    onSubmitQuestion,
    onChangeTime,
    resetPracticeTest,
  } = useContext(AppContext);

  const { theme, currentTheme } = useContext(ThemeContext);
  const { selectedCertificate } = useContext(BundleContext);
  const { trackTestStart, trackTestComplete, trackTestAbandon, trackQuestionAnswer, trackUserAction } = useAnalytics();
  
  const { state } = useLocation();

  const [isLoading, setLoading] = useState(false);
  const [quickSetState, setQuickSetState] = useState({
    selectedOpion: null,
  });
  const [currentIndex, setCurrentIndex] = useState(0);
  const [lastIndex, setLastIndex] = useState(0);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [savedAnswers, setSavedAnswers] = useState([]);
  const [isTimeup, setTimeup] = useState(false);
  const [isTestExitPopup, setTestExitPopup] = useState(false);
  const [isTestEndPopup, setTestEndPopup] = useState(false);
  const [historyTimeup, setHistoryTimeup] = useState(null);
  const [testStarted, setTestStarted] = useState(true);
  const lastReadinessScore = profile?.readiness_scores?.readiness_score;
  const [isSubmitAnswer, setSubmitAnswer] = useState({});

  const numberOfQuestion = state?.numberOfQuestion;
  const isShowAnswer =
    state?.isShowAnswer || state?.is_show_answer ? true : false;
  const practiceTest = state ?? null;
  const OPTIONS = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

  const navigation = useNavigate();
  const historyRef = useRef(null);
  historyRef.current = history;

  const timeRef = useRef(null);
  timeRef.current = history?.remaining_time;

  const lastIndexRef = useRef(null);
  lastIndexRef.current = lastIndex;

  // Track test start when component mounts
  useEffect(() => {
    if (practiceTest && testStarted) {
      const testType = practiceTest.is_custom_test ? 'custom_test' : 'practice_test';
      const testId = practiceTest.test_id || practiceTest.test_name || 'unknown';
      
      trackTestStart(testType, testId, {
        test_name: practiceTest.test_name,
        question_count: numberOfQuestion,
        time_limit: practiceTest.test_time,
        is_show_answer: isShowAnswer,
        exam_type: selectedCertificate
      });
    }
  }, [practiceTest, testStarted]);

  const styles = {
    questionCard: {
      background: theme.dashboard.card.background,
      border: `1px solid ${theme.dashboard.card.border}`,
      borderRadius: '1rem',
      boxShadow: theme.dashboard.card.shadow,
      marginBottom: '2rem',
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
    },
    questionContent: {
      padding: '2rem',
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
    },
    questionText: {
      marginBottom: '2rem',
      color: theme.text.primary,
      fontSize: '1.125rem',
      lineHeight: '1.7',
    },
    optionsGrid: {
      display: 'grid',
      gap: '1rem',
      gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
      alignItems: 'stretch',
    },
  }

  async function onSaveTestHistory(isTimeup) {
    let historyData = { ...historyRef.current };
    console.log("historyData", historyData);

    if (practiceTest?.is_custom_test && practiceTest?.total_time > 0) {
      const totalItems = historyData?.test_questions_meta_data ?? [];
      const attemptQuestions = totalItems.splice(0, lastIndexRef.current + 1);
      historyData.test_questions_meta_data = attemptQuestions;
      console.log("attemptQuestions", attemptQuestions);

      const correct =
        attemptQuestions?.filter((item) => item.response == STRING.correct_tag)
          ?.length ?? 0;
      const incorrect =
        attemptQuestions?.filter(
          (item) => item.response == STRING.incorrect_tag
        )?.length ?? 0;
      const unanswered =
        attemptQuestions?.filter(
          (item) => item.response == STRING.unanswered_tag
        )?.length ?? 0;

      historyData.correct = correct;
      historyData.incorrect = incorrect;
      historyData.unanswered = unanswered;
      historyData.total = attemptQuestions.length;
      historyData.score = parseInt((correct * 100) / attemptQuestions.length);
    }
    setTestHistory(historyData).catch(error => {
      console.error('Failed to save test history:', error);
    });
    setHistoryTimeup(historyData);

    if (!isShowAnswer) {
      var list = [];
      const question_array = historyData?.test_questions_meta_data ?? [];
      question_array.forEach((element) => {
        list.push({
          question_id: element?.question_id,
          topic_id: element?.topic_id,
          correct: element?.response == STRING.correct_tag,
          selected: element?.response,
        });
      });
      addAllQuestionScore(list);
    }

    const total = historyData?.test_questions_meta_data?.length ?? 0;
    const unanswered =
      historyData?.test_questions_meta_data?.filter(
        (item) => item.response == STRING.unanswered_tag
      )?.length ?? 0;
    const answered = total - unanswered;

    if (isTimeup) {
      // Track test abandonment due to time up
      const testType = practiceTest?.is_custom_test ? 'custom_test' : 'practice_test';
      const testId = practiceTest?.test_id || practiceTest?.test_name || 'unknown';
      
      trackTestAbandon(testType, testId, 'time_up', {
        questions_answered: answered,
        total_questions: total,
        time_remaining: 0,
        score: historyData.score
      });
     
      setTimeup(true);
    } else {
      // Track test completion
      const testType = practiceTest?.is_custom_test ? 'custom_test' : 'practice_test';
      const testId = practiceTest?.test_id || practiceTest?.test_name || 'unknown';
      const duration = practiceTest?.test_time ? practiceTest.test_time - historyData?.remaining_time : 0;
      
      trackTestComplete(testType, testId, historyData.score, duration, {
        questions_answered: answered,
        total_questions: total,
        correct_answers: historyData.correct,
        unanswered_questions: unanswered
      });

      navigation("/testReview", { state: { historyData, canGoBackKey: false, lastReadinessScore } });

      resetPracticeTest();
    }
  }

  const backAction = () => {
    onBack();
    return true;
  };

  function onBack() {
    setTestExitPopup(true);
  }

  function onExit() {
    const total = history?.test_questions_meta_data?.length ?? 0;
    const unanswered =
      history?.test_questions_meta_data?.filter(
        (item) => item.response == STRING.unanswered_tag
      )?.length ?? 0;
    const answered = total - unanswered;

    // Track test abandonment
    const testType = practiceTest?.is_custom_test ? 'custom_test' : 'practice_test';
    const testId = practiceTest?.test_id || practiceTest?.test_name || 'unknown';
    
    trackTestAbandon(testType, testId, 'user_exit', {
      questions_answered: answered,
      total_questions: total,
      exit_reason: 'user_initiated'
    });

    onUpdateScore();
    resetPracticeTest();

    if (practiceTest?.is_retake_test) {
     
      navigation("/home", { state: { isShowReview: true } });
    } else {
      // props.navigation.goBack()
      navigation(-1);
    }
  }

  function onUpdateScore() {
    // add score if show answer is true and selected index is not X and is not from older
    if (
      selectedIndex &&
      selectedIndex.selected != "X" &&
      isShowAnswer &&
      selectedIndex.is_from_older == false
    ) {
      addQuestionScore(
        currentItem?.question.id,
        currentItem?.question.topic_id,
        currentItem?.question.correct_answer == selectedIndex.selected
      );
    }
  }

  function getCurrentQuestion() {
    
    
    if (
      history?.test_questions_meta_data?.length > 0 &&
      !isNaN(currentIndex) &&
      history?.test_questions_meta_data?.length > currentIndex
    ) {
      const id = history?.test_questions_meta_data[currentIndex]?.question_id;
      
      const question = GET_QUESTION_FROM_ID(questionsList, id);
      
      return question;
    } else {
      console.log("[getCurrentQuestion] Returning null - conditions not met");
      return null;
    }
  }

  function getTopicId() {
    const APP_DOMAIN_LIST = GET_APP_DOMAIN_LIST(selectedCertificate);
    const array = APP_DOMAIN_LIST.find(
      (item) => item.id == currentItem?.question?.topic_id
    );
    return array?.domain_name ?? "";
  }

  function onPrevious() {
    onUpdateScore();
    setSelectedIndex(null);
    // scrollRef.current.scrollTo({ x: 0, y: 0, animated: false });
    setCurrentIndex((state) => {
      return state == 0 ? 0 : state - 1;
    });
  }

  function onNext() {
    onUpdateScore();
    setSelectedIndex(null);
    // scrollRef.current.scrollTo({ x: 0, y: 0, animated: false })

    if (currentIndex + 1 >= lastIndexRef.current) {
      setLastIndex(currentIndex + 1);
    }

    setCurrentIndex((state) => {
      return state == history?.test_questions_meta_data.length - 1
        ? 0
        : state + 1;
    });
  }

  function onEndTest() {
    onUpdateScore();
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setTimeout(() => {
        setTestEndPopup(true);
      }, 100);
    }, 500);
  }

  const currentItem = getCurrentQuestion();
  const time = toHHMMSS(history.remaining_time);
  const topic = getTopicId();

  useEffect(() => {
    if (history?.test_questions_meta_data?.length > 0) {
      setSelectedIndex({
        selected:
          history?.test_questions_meta_data[currentIndex]?.selected_choice,
        is_from_older: true,
      });
    }
  }, [currentIndex]);

  useEffect(() => {
    let timer = null;

    if (!isShowAnswer && history.total_time) {
      timer = setInterval(() => {
        if (timeRef.current <= 0) {
          clearInterval(timer);
          /* setTimeout(() => {
            onSaveTestHistory(true);
          }, 1000); */
            onUpdateScore();
            setLoading(true);
            setTimeout(() => {
              setLoading(false);
              setTimeout(() => {
                setTimeup(true);
              }, 500);
            }, 1000);
          
        } else {
          onChangeTime();
        }
      }, 1000);
    }

    return () => clearInterval(timer);
  }, [isShowAnswer, history.total_time]);

  useEffect(() => {
    fetchQuestionList();
  }, []);

  const setSelectedAnswer = (questionId, selectedOption) => {
    // setQuickSetState((prev) => ({
    //   ...prev,
    //   selectedOpion: selectedOption,
    // }));
  };

  function fetchQuestionList() {
    const questionTime = profile?.time_per_question
      ? profile?.time_per_question
      : community?.total_time_per_question ?? 90;

    if (practiceTest?.is_custom_test) {
      const result = GET_CUSTOM_TEST_DETAILS(
        questionsList,
        questionTime,
        practiceTest,
        profile,
        questionScrore
      );

      initalizePracticeTest(result);
    } else if (practiceTest?.is_retake_test) {
      const result = GET_RETAKE_TEST_DETAILS(practiceTest);
      initalizePracticeTest(result);
    } else {
      const result = GET_PRACTICE_TEST_DETAILS(
        questionsList,
        questionTime,
        practiceTest,
        numberOfQuestion
      );
      initalizePracticeTest(result);
    }
  }

  return (
    
      <div className="min-h-screen transition-colors duration-300" 
         style={{ background: theme?.background?.main }}>
      <div className="mx-4 sm:mx-4 md:mx-8 lg:mx-8 mb-4 sm:mb-4 md:mb-8 lg:mb-8">
        
        <CommonHeader
          title={history?.test_name || state?.test_name}
          subtitle="Test your knowledge and track your progress"
          icon={faClipboardCheck}
          iconType="fontawesome"
          onBack={() => {
            if (!isTestEndPopup && !isTimeup) {
              setTestExitPopup(true);
            } else {
              navigation(-1);
            }
          }}
          theme={theme}
          showBackButton={true}
        />

        {/* Progress */}
        <TestProgress
          currentIndex={currentIndex}
          totalQuestions={history?.test_questions_meta_data?.length || 0}
          answeredQuestions={history?.test_questions_meta_data?.filter(
            (item) => item.response !== STRING.unanswered_tag
          )?.length || 0}
          remainingTime={time}
          theme={theme}
        />

        {/* Question Content */}
        
          {currentItem ? (
            <div style={styles.questionCard}>
            <div style={styles.questionContent}>
            <div style={styles.questionText}>
            <HTMLContent
              index={currentItem?.question?.id}
              htmlContent={currentItem?.question?.question || ''}
              //className="bg-gray-100 dark:bg-zinc-900 p-4 rounded-lg"
              style={{ 
                fontSize: '1.125rem',
                lineHeight: '1.75',
                color: theme?.text?.primary,
              }}
            />
            </div>

            <div className="grid gap-4 grid-cols-1 md:grid-cols-2">
              {currentItem?.choices?.map((options, index) => {
                const isSelected = selectedIndex
                  ? selectedIndex.selected == OPTIONS[index]
                  : false;

                return (
                  <>
                    <QuestionOptions
                      key={index + JSON.stringify(options)}
                      index={index}
                      item={options}
                      isShowAnswer={isShowAnswer}
                      correct={currentItem?.question?.correct_answer}
                      selected={
                        history?.test_questions_meta_data[currentIndex]
                          ?.selected_choice
                      }
                      isSubmit={(isSubmitAnswer?.[currentIndex] ?? false)}
                      onPress={() => {
                        const selected = OPTIONS[index];
                        const correct = currentItem?.question?.correct_answer;
                        const item =
                          history?.test_questions_meta_data[currentIndex];
                        if (Array.isArray(correct)) {
                          const previousSelectedOptions = history?.test_questions_meta_data?.[currentIndex]?.selected_choice == 'X' ? [] : (history?.test_questions_meta_data?.[currentIndex]?.selected_choice ?? [])
                          //const previousSelectedOptions = history?.test_questions_meta_data?.[currentIndex] ?.selected_choice ?? [];
                          if (previousSelectedOptions.includes(selected)) {
                            let selectedOptions = [...previousSelectedOptions];
                            selectedOptions = selectedOptions.filter(
                              (e) => e != selected
                            );
                            item.selected_choice = selectedOptions;
                          } else {
                            const selectedOptions = [
                              ...previousSelectedOptions,
                            ];
                            selectedOptions.push(selected);
                            item.selected_choice = selectedOptions;
                          }
                          let isCorrect = true;
                          /* correct.forEach((element) => {
                            if (!item?.selected_choice?.includes(element)) {
                              isCorrect = false;
                            }
                          }); */
                          if (correct?.length == item?.selected_choice?.length)  {
                            correct.forEach(element => {
                                if (!item?.selected_choice?.includes(element)) {
                                    isCorrect = false
                                }
                            });
                        }
                        else {
                            isCorrect = false
                        }

                          if (selected.length > 0) {
                            item.response = isCorrect
                              ? STRING.correct_tag
                              : STRING.incorrect_tag;
                          } else {
                            item.response = STRING.unanswered_tag;
                          }
                          onSubmitQuestion(currentIndex, item);
                          //console.log("selected", item.selected_choice);
                          setSelectedIndex({ selected: item.selected_choice, is_from_older: false });
                        } else {
                          item.selected_choice = selected ?? "X";
                          if (selected != "X" && selected != null) {
                            item.response =
                              correct == selected
                                ? STRING.correct_tag
                                : STRING.incorrect_tag;
                          } else {
                            item.response = STRING.unanswered_tag;
                          }
                          if (!isShowAnswer) {
                            onSubmitQuestion(currentIndex, item);
                            setSelectedIndex({
                              selected: selected,
                              is_from_older: false,
                            });
                          } else
                          /* if (
                            (!selectedIndex || selectedIndex.selected == "X") && isShowAnswer == true
                          )  */ {
                            onSubmitQuestion(currentIndex, item);
                            setSelectedIndex({ selected: selected, is_from_older: false });

                            // Track question answer
                            if (currentItem?.question) {
                              const isCorrect = currentItem.question.correct_answer === selected;
                              trackQuestionAnswer(
                                currentItem.question.id,
                                isCorrect,
                                topic,
                                {
                                  question_index: currentIndex,
                                  time_spent_seconds: 0, // You can calculate this if needed
                                  attempt_number: 1,
                                  test_type: practiceTest?.is_custom_test ? 'custom_test' : 'practice_test'
                                }
                              );
                            }

                            const submitted = { ...isSubmitAnswer }
                            submitted[currentIndex] = true
                            setSubmitAnswer(submitted)

                          }
                        }
                      }}
                    />
                  </>
                );
              })}
            </div>
            {isShowAnswer && (isSubmitAnswer?.[currentIndex] ?? false) == false && Array.isArray(currentItem?.question?.correct_answer) && selectedIndex && selectedIndex?.selected != '' && selectedIndex?.selected != 'X' && selectedIndex?.selected?.length > 0 &&
              <div className="flex justify-center items-center">
                <div className="w-full md:w-auto p-4">
                  <button
                      className="my-4 py-2 px-6 rounded-full bg-lz-blue text-white text-sm font-semibold text-center"
                      onClick={() => {
                          const submitted = { ...isSubmitAnswer };
                          submitted[currentIndex] = true;
                          setSubmitAnswer(submitted);
                      }}
                  >
                      Submit Answer
                  </button>
              </div>
            </div>
            }
            {isShowAnswer && (isSubmitAnswer?.[currentIndex] ?? false) && selectedIndex && selectedIndex.selected != 'X' &&
            (
              <div className="pt-6">
                <AnswerMessage
                    correct_answer={currentItem?.question?.correct_answer}
                    selected_answer={selectedIndex.selected}
                />
                <ExplanationComponent
                  explanation={currentItem.question?.explanation ?? ""}
                  topic={topic}
                  sub_domain={
                    currentItem?.question?.sub_domain
                      ? currentItem?.question?.sub_domain
                      : ""
                  }
                />
                
              </div>
              
            )}
          </div>
        </div>
          ) : (
            <div style={styles.questionCard}>
              <div style={styles.questionContent}>
                <div style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  padding: '3rem',
                  color: theme.text.secondary,
                  fontSize: '1.125rem'
                }}>
                  <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mr-3"></div>
                  Loading question...
                </div>
              </div>
            </div>
          )}
          </div>

        {/* Footer Navigation */}
        <NavBar
        type="test"
        onNext={onNext}
        onPrevious={onPrevious}
        currentIndex={currentIndex}
        dataSet={history?.test_questions_meta_data?.length || 0}
        navTitle="Practice Test"
        showEnd={true}
        onEndTest={onEndTest}
        isLoading={isLoading}
      />

      {/* Loading Overlay */}
      {isLoading && (
        <div 
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
          }}
        >
          <div 
            style={{
              background: theme.dashboard.card.background,
              padding: '2rem',
              borderRadius: '1rem',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '1rem',
              boxShadow: theme.dashboard.card.shadow,
            }}
          >
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
            <div style={{ color: theme.text.primary, fontWeight: 600 }}>
              Processing your test results...
            </div>
          </div>
        </div>
      )}

      {/* Modals */}
      <TestExitModal
        isOpen={isTestExitPopup}
        onClose={() => setTestExitPopup(false)}
        onConfirm={() => {
          navigation(-1, { state: { isFromBack: true } });
          setTestExitPopup(false);
        }}
        theme={theme}
      />

      <TestEndModal
        isOpen={isTestEndPopup}
        onClose={() => setTestEndPopup(false)}
        onConfirm={() => {
          setTestEndPopup(false);
          onSaveTestHistory(false);
        }}
        theme={theme}
      />

      <TestTimeUpModal
        isOpen={isTimeup}
        onConfirm={() => {
          setTimeup(false);
          onSaveTestHistory(true);
        }}
        theme={theme}
      />
      </div>
    
  );
};

export default Test;
